<h1 mat-dialog-title class="text-xl font-medium">Prompt Import / Export</h1>
<mat-dialog-content>
    <mat-tab-group
        class="-mx-6 mt-4"
        [selectedIndex]="selectedTabIndex()"
        (selectedIndexChange)="selectedTabIndex.set($event)">
        <mat-tab label="Importieren">
            <app-import-prompts [directories]="(directories$ | async) ?? []"></app-import-prompts>
        </mat-tab>
        <mat-tab label="Exportieren">
            <app-export-prompts [directories]="directories$"></app-export-prompts>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (selectedTabIndex() === 0) {
        @if (importComponent()?.importCompleted()) {
            <button mat-button mat-dialog-close>Schließen</button>
        } @else {
            <button mat-button mat-dialog-close>Abbrechen</button>
            <button
                class="gap-2"
                mat-flat-button
                color="primary"
                [disabled]="
                    importComponent()?.importForm?.invalid ||
                    !importComponent()?.selectedFile() ||
                    importComponent()?.isLoading()
                "
                (click)="importComponent()?.onSubmit()">
                <mat-icon svgIcon="mat_outline:upload"></mat-icon>
                Importieren
            </button>
        }
    } @else {
        @if (exportComponent()?.exportCompleted()) {
            <button mat-button mat-dialog-close>Schließen</button>
        } @else {
            <span class="text-md ml-4 mr-auto text-gray-600">
                {{ exportComponent()?.selectedCount() || 0 }} Prompt{{
                    exportComponent()?.selectedCount() === 1 ? '' : 's'
                }}
                ausgewählt
            </span>
            <button mat-button mat-dialog-close>Abbrechen</button>
            <button
                class="gap-2"
                mat-flat-button
                color="primary"
                [disabled]="!exportComponent()?.selectedCount()"
                (click)="exportComponent()?.exportPrompts()">
                <mat-icon svgIcon="mat_outline:download"></mat-icon>
                Exportieren
            </button>
        }
    }
</mat-dialog-actions>
